import { render, staticRenderFns } from "./WhatsNewSearchInput.vue?vue&type=template&id=8ef53f52&scoped=true"
import script from "./WhatsNewSearchInput.vue?vue&type=script&lang=js"
export * from "./WhatsNewSearchInput.vue?vue&type=script&lang=js"
import style0 from "./WhatsNewSearchInput.vue?vue&type=style&index=0&id=8ef53f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef53f52",
  null
  
)

export default component.exports